export default "__VITE_ASSET__hs1jK0AD__"